export const AuthLayout = ({ children }) => {
  return (
    <div className="480:max-w-[440px] min-h-screen 480:mx-auto 480:flex 480:flex-col 480:justify-center">
      <div className="h-full 480:h-[800px] 480:p-5 relative 480:shadow-xl 480:shadow-blue-500">
        <div className="h-full 480:h-[760px] 480:overflow-y-scroll thin-scrollbar">
          <div className="480:w-full 480:h-full 480:bg-white ">
            <div className="bg-white h-full ">{children}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
